import { render } from "./FaceScene.vue?vue&type=template&id=1d3063d2&scoped=true"
import script from "./FaceScene.vue?vue&type=script&lang=js"
export * from "./FaceScene.vue?vue&type=script&lang=js"

import "./FaceScene.vue?vue&type=style&index=0&id=1d3063d2&scoped=true&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3063d2"]])

export default __exports__